import React from "react";
import { User } from "lucide-react";
import { team } from "../mock";

// Subtle unified treatment to harmonise photos (kept in colour)
const PHOTO_FILTER = {
  filter: "saturate(0.92) contrast(1.03)",
};

const TeamCard = ({ member, highlighted }) => {
  const hasPhoto = Boolean(member.photo);
  return (
    <article
      className="group relative overflow-hidden bg-[#F7F4EF] transition-all duration-500 hover:shadow-2xl active:scale-[0.985] cursor-default"
    >
      {/* Photo slot — uniform ratio */}
      <div className="relative aspect-[3/4] w-full bg-[#1a1a1a] overflow-hidden">
        {hasPhoto ? (
          <img
            src={member.photo}
            alt={member.name}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
            style={PHOTO_FILTER}
            loading="lazy"
          />
        ) : (
          // Clean, sober empty photo slot ready for a real portrait
          <div
            className="absolute inset-0 flex items-center justify-center"
            style={{ background: "#1a1a1a" }}
          >
            {/* Subtle silhouette */}
            <div className="flex flex-col items-center gap-4">
              <div className="w-20 h-20 rounded-full border border-[#9F8B76]/40 flex items-center justify-center">
                <User className="w-9 h-9 text-[#9F8B76]/60" strokeWidth={1.3} />
              </div>
              <span className="text-[10px] uppercase tracking-[0.3em] text-white/40">
                Photo à venir
              </span>
            </div>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
      </div>

      {/* Text block */}
      <div className="px-5 md:px-6 py-5 md:py-6 bg-[#F7F4EF]">
        <h3
          className="font-display uppercase text-neutral-900 leading-none"
          style={{ fontSize: "clamp(20px, 1.7vw, 26px)" }}
        >
          {member.name}
        </h3>
        <p className="mt-2 text-neutral-500 text-[13px] leading-snug">
          {member.role}
        </p>
      </div>
    </article>
  );
};

const Equipe = () => {
  return (
    <section id="equipe" className="bg-[#E9E1D4] py-24 md:py-32" data-nav-theme="light">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <h2
          className="font-display uppercase text-neutral-900 leading-[0.95] mb-14 md:mb-20"
          style={{ fontSize: "clamp(38px, 5vw, 84px)" }}
        >
          L'équipe Labroca
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {team.map((m, i) => (
            <TeamCard key={m.id} member={m} highlighted={i === 0} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Equipe;
